import React from "react";

const Dropdown22 = () => {
  return <div className="dropdown-22">Dropdown 22</div>;
};

export default Dropdown22;
